import * as types from '../mutation-types'
import { stateManager } from '../helper'
import router from '@/router'

const sm = stateManager({ preRoute: null })

export default {
  state: sm.get(),
  mutations: {
    [types.PRE_ROUTE_SAVE] (state, route) {
      state.preRoute = route
    },
    [types.HISTORY_RESET] (state) {
      sm.reset(state)
    }
  },
  actions: {
    savePreRoute ({ commit }, route) {
      commit(types.PRE_ROUTE_SAVE, route)
    },
    back ({ getters }) {
      if (!getters.preRoute || !getters.preRoute.name) {
        const name = getters.isLoggedIn ? 'library' : 'home'
        router.replace({ name })
        return
      }

      router.back()
    }
  },
  getters: {
    preRoute (state) {
      return state.preRoute
    }
  }
}
